import { IRequest } from '@r1-frontend/shared/types/IRequest';

export enum EAvailability {
    UNAVAILABLE = -1,
    AVAILABLE = 1,
    REGISTRED = 2,
}

export interface IAvailability {
    available: EAvailability,
}

/*
* Доступность программы лояльности
* https://master.api-loyalty.sandbox.d2c.r-one.io/docs/v1#/Loyalty%20Program/fa8b96dbaa28f3a0e05ad3f3a7cd4c4f
* */
export const availability = (providerId: number): IRequest => ({
    uri: '/v1/program/availability',
    method: 'GET',
    withAuth: true,
    headers: { providerId: `${providerId}` },
});
